import React from 'react';
import { Progress } from 'reactstrap'; // Assuming you're using Reactstrap

const LinearProgressBar = ({ percentage }) => (
  <Progress
    value={percentage}
    style={{
      ...linearProgressStyle,
      transition: 'width 1s ease-in-out', // Smoother transition
    }}
  />
);

const linearProgressStyle = {
  height: '10px',
  backgroundColor: '#e0e0e0',
  borderRadius: '5px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  marginTop: '20px',
  width: '100%',
};

export default LinearProgressBar;
